import React from 'react';
import LanguageCurrencyToggleProps from './props';
import "./styles.scss";

function LanguageCurrencyToggle(props: LanguageCurrencyToggleProps) {
  const {
    handleToggle,
    flagCountryUrl,
    countryName,
    languageName,
    currencyName,
    hideCurrency
  } = props;

  return (
    <button className="language-currency-toggle" onClick={handleToggle} type="button">
      <div id="flag" className="language-currency-toggle__flag">
        <img
          src={`${flagCountryUrl}`}
          alt={`${countryName} flag`}
        />
      </div>
      <div className="language-currency-toggle__container">
        <div className="language-currency-toggle__country">{countryName}</div>
        <div className="language-currency-toggle__delimiter-hyphen">&#45;</div>
        <div
          className={`language-currency-toggle__container-language-currency`}
        >
          <div className="language-currency-toggle__language">
            {languageName}
          </div>
          <div
            className={`language-currency-toggle__delimiter-bullet ${
              hideCurrency ? 'hidden' : ''
            }`}>&bull;</div>
          <div
            className={`language-currency-toggle__currency ${
              hideCurrency ? 'hidden' : ''
            }`}
          >
            {currencyName}
          </div>
        </div>
      </div>
    </button>
  );
}

export default LanguageCurrencyToggle;
